import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { useContext } from 'react';
import { HeaderSize } from '..';
import { ViewportContext } from '../../../hooks/useViewport';
import { styleSheet } from '../styles';

interface Props {
	headerHeight: HeaderSize;
	children: React.ReactNode;
	styles?: StyleDeclarationValue[];
}

export const BodyContainer = ({ children, headerHeight, styles = [] }: Props) => {
	const { isBelowSmall } = useContext(ViewportContext);
	return (
		<div
			// Read by useScrollRestoration (web/components/ScrollRestoration) to persist this scroll container per URL.
			data-scroll-restoration-id='aida-main-body'
			className={css(
				styleSheet.bodyContainer,
				isBelowSmall
					? styleSheet.mobileHeader
					: headerHeight === 'tall'
						? styleSheet.tallHeader
						: styleSheet.shortHeader,
				...styles
			)}
		>
			{children}
		</div>
	);
};
